import LabeledValueTable, {
  LabeledValueRow,
  LabeledValueTableProps,
} from "components/Shared/LabeledValueTable";

type Props = LabeledValueTableProps & {
  columns?: string[];
  valuesByColumn: { [column: string]: string };
};

export default function ColumnValues({
  columns,
  labelProps,
  valuesByColumn,
  ...rest
}: Props) {
  const cols = columns || Object.keys(valuesByColumn);
  return (
    <LabeledValueTable
      labelProps={{
        fontFamily: "mono",
        fontWeight: 600,
        ...labelProps,
      }}
      {...rest}
    >
      {cols.map((col) => (
        <LabeledValueRow key={col} label={col} value={valuesByColumn[col]} />
      ))}
    </LabeledValueTable>
  );
}
